#import "../../list/AccessGroupsFields.graphql"

mutation AccessGroupUpdate($input: AccessGroupUpdateInput!) {
  accessGroupUpdate(input: $input) {
    clientMutationId
    accessGroupUpdateType {
      _isCompanyTokenRefreshRequired
      accessGroup {
        ...AccessGroupsFields
      }
    }
  }
}